import { Component, OnInit, Input, ViewChild, OnDestroy } from "@angular/core";
import { HttpServiceCustomer } from "src/app/services/Customer/http/http.service_Customer";
import { CustomerIn, CustomerStepVisitIn } from "src/classes/Customers/CustCard_1";
import { Visit, Total, StripVisit, SubStripVisit, StripIn } from "src/classes/Customers/Visit";
import { Menu } from "primeng/menu";
import { PopupItem } from "src/classes/Common/PopupItem";
import { MessageService } from "primeng/api";
import { ExtendedMenuItem } from "src/classes/Common/PrimeNGMenuItem";
import { screenId } from "src/environments/environment";
import { Control } from "src/classes/Authorization/BusinessRole";
import { CommonFunctions } from "src/app/helper/CommonFunctions";
import { SetValid } from "src/classes/Common/SetValid";
import { ControlsService } from "src/app/services/Common/controls.service";
import { Config } from "src/classes/Common/ConfigData";
import { Table } from "primeng/table";
import { Worker } from "src/classes/Common/Worker";
import { CustCardTabService } from "src/app/services/Custcard/cust-card-tab/cust-card-tab.service";
import { DynamicDialogService } from "src/app/services/Customer/dynamic-dialog/dynamic-dialog.service";
import { HostListenerBeforeUnloadDirective } from "src/app/services/Common/host-listener-before-unload.directive";
import { NGXLogger } from "ngx-logger";

type StripVisitType = StripVisit & { isChanged?: boolean };

@Component({
    selector: "app-custcardview46",
    templateUrl: "./custcardview46.component.html",
    styleUrls: ["./custcardview46.component.css"],
    providers: [HttpServiceCustomer, CommonFunctions, MessageService]
})
export class Custcardview46Component implements OnInit, OnDestroy {
    @Input() customerId: number = 0;
    @Input() customerFl: string = "";

    customerin: CustomerIn = new CustomerIn();
    customerstepvisitin: CustomerStepVisitIn = new CustomerStepVisitIn();
    config: Config = new Config();
    controls: Control[];
    keylength: number = 12;
    receivedvalid: SetValid = new SetValid();

    visit: Visit = new Visit();
    multi: SubStripVisit[][] = [[], []];
    stripId: string = "";
    subStripId: string = "";
    visits: StripVisitType[];
    tmpVisits: StripVisitType[] = [];

    openedMenu: Menu;
    items: ExtendedMenuItem[];
    items_1: ExtendedMenuItem[];
    items_2: ExtendedMenuItem[];
    items_3: ExtendedMenuItem[];

    customClassificationVisit: string[] = ["הכל", "חשבוניות", "טיפולים", "מוצרים"];
    dateClassificationVisit: string[] = ["הכל", "עתידיים בלבד", "בעבר", "מבוטלים בלבד"];
    classificationOption: string = "הכל";
    dateclassificationOption: string = "הכל";

    workers: Worker[] = [];

    isDeletingStripVisit: boolean = false;
    isDeletingSubstripVisit: boolean = false;

    isEditComment: boolean = false;
    openedComment: string;

    isEditPurchase: boolean = false;
    purchaseTotal: string;
    purchaseAmount: string;
    purchaseDiscountPrice: string;
    purchaseDiscountPercent: string;
    purchaseClientPrice: string;
    purchaseName: string;
    purchaseSaparName: string;
    purchaseNumColor: number;

    isEditService: boolean = false;
    serviceTotal: string;
    serviceDiscountPrice: string;
    serviceDiscountPercent: string;
    serviceClientPrice: string;
    serviceName: string;
    serviceSaparName: string;
    servicesNumColor: number;

    isPurchaseMenuOpened: boolean = false;
    isServiceMenuOpened: boolean = false;
    isVisitMenuOpened: boolean = false;

    isDeletingPurchase: boolean = false;

    isPanelsInfoOpened: boolean = false;

    previousTab: number = 0;
    saveData: boolean = false;
    componentHasChanged: boolean = false;

    messageVisibleTimeout: ReturnType<typeof setTimeout>;
    messageSummary: string;

    @ViewChild("maintable", { static: false }) maintable: Table;
    @ViewChild("hostListenerBeforeUnload", { static: false }) hostListenerBeforeUnload: HostListenerBeforeUnloadDirective;

    constructor(
        private httpServiceCustomer: HttpServiceCustomer,
        private commonFunc: CommonFunctions,
        private controlsService: ControlsService,
        private dynamicDialogService: DynamicDialogService,
        private messageService: MessageService,
        private custCardTabService: CustCardTabService,
        private logger: NGXLogger
    ) {
        custCardTabService.tabChanged.subscribe((tabIndex: number) => this.onTabChange(tabIndex));
    }

    ngOnInit() {
        enum MenuEnum {
            FourthMenu = 4,
            FifthMenu = 5,
            SixthMenu = 6
        }

        this.customerin.customer_id = this.customerId;
        this.customerstepvisitin.customer_id = this.customerId;
        this.controls = JSON.parse(sessionStorage.getItem("custcardview_controls_roles"));

        this.visit.total = new Total();

        this.httpServiceCustomer.getVisit(this.customerin)
            .subscribe((res: Visit) => {
                this.visit = res;

                if (this.visit.total) {
                    this.customerstepvisitin.dateEvent = res.total.dateEvent;
                }

                this.visits = res.strips.slice().sort((item1, item2) => {
                    return this.commonFunc.stringToDate(item2.dateVisit).getTime() - this.commonFunc.stringToDate(item1.dateVisit).getTime();
                });
                this.visits.forEach((item: StripVisitType) => item.isChanged = false);

                this.tmpVisits = this.visits;
                console.log("count of visits:" + this.visit.strips.length);
                // this.visit.strips.forEach((x)=>x.substrips=new Array());
                console.log(res)
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        // Get the list of items in popup
        this.httpServiceCustomer.getItemsMenuByScreen({ screen_id: screenId.Customers.custcardview })
            .subscribe((res: [PopupItem]) => {
                let m: ExtendedMenuItem[] = [];
                res.forEach((item) => {
                    const menuItem: ExtendedMenuItem = {
                        label: item.mn_menuitem_title,
                        icon: item.mn_icon.split(".svg")[0],
                        menu_Id: item.mn_menu_id,
                        disabled: item.cb_id_disable != -1 ? this.isDisabled(item.cb_id_disable) : false,
                        command: () => this.menuItemCommand(item.mn_menu_id, item.mn_order_id)
                    };
                    m.push(menuItem);
                });

                this.items = m;
                this.items_1 = this.items.filter((item: ExtendedMenuItem) => item.menu_Id == MenuEnum.FourthMenu);
                this.items_2 = this.items.filter((item: ExtendedMenuItem) => item.menu_Id == MenuEnum.FifthMenu);
                this.items_3 = this.items.filter((item: ExtendedMenuItem) => item.menu_Id == MenuEnum.SixthMenu);
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        // Get business configuration
        this.httpServiceCustomer.getConfig()
            .subscribe((data: Config) => {
                this.config = data;
                console.log("BusinessID:" + this.config.remotebusid);
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        // Get workers list
        this.httpServiceCustomer.getWorkers()
            .subscribe((res: Worker[]) => {
                this.workers = res;

                this.workers.shift();
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }

    ngOnDestroy(): void {
        this.custCardTabService.tabIndex = 57;
        this.dynamicDialogService.closeDialog();
        this.saveVisits();
    }

    onTabChange(tabIndex: number): void {
        // Handle tab change event here
        if (tabIndex == 46) {
            this.saveData = false;
        }

        if (this.previousTab == 46) {
            this.dynamicDialogService.closeDialog();
            this.saveVisits();
        }
        this.previousTab = tabIndex;
    }

    // Hide the menu when scrolling
    onScroll(): void {
        if (this.openedMenu) {
            this.openedMenu.hide();
        }
    }

    // Commands for menu items by their id
    menuItemCommand(menu_id: number, order_id: number): void {
        if (menu_id == 4) {
            // development in the next version
        }
        else if (menu_id == 6 && order_id == 1) {
            //open the service editing modal
            this.isServiceMenuOpened = false;
            this.isEditService = true;

            let tmpSubStrip: SubStripVisit = this.multi[this.subStripId.split(" ")[0]].find((x) => x.id == this.subStripId.split(" ")[1]);

            this.serviceClientPrice = tmpSubStrip.clientPrice;
            this.serviceTotal = tmpSubStrip.pricePerchase;
            this.serviceDiscountPrice = tmpSubStrip.discountPrice;
            this.serviceDiscountPercent = tmpSubStrip.percentAmount;
            this.serviceName = tmpSubStrip.serviceNamestr;
            this.serviceSaparName = tmpSubStrip.saparName;
            this.servicesNumColor = tmpSubStrip.numColor;
            // if (!this.serviceDiscountPrice) {
            //     this.serviceDiscountPrice = this.serviceClientPrice;
            // }
            // if (!this.serviceDiscount) {
            //     if (this.serviceDiscountPrice > this.serviceClientPrice) {
            //         this.serviceDiscount = 0;
            //     }
            //     else {
            //         this.serviceDiscount = (1 - this.serviceClientPrice / this.serviceDiscountPrice) * 100;
            //     }
            // }
        }
        else if (menu_id == 5 && order_id == 1) {
            //open the purchase editing modal
            this.isPurchaseMenuOpened = false;
            this.isEditPurchase = true;

            let tmpSubStrip: SubStripVisit = this.multi[this.subStripId.split(" ")[0]].find((x) => x.id == this.subStripId.split(" ")[1]);

            this.purchaseClientPrice = tmpSubStrip.clientPrice;
            this.purchaseTotal = tmpSubStrip.pricePerchase;
            this.purchaseAmount = tmpSubStrip.amount;
            this.purchaseDiscountPrice = tmpSubStrip.discountPrice;
            this.purchaseDiscountPercent = tmpSubStrip.percentAmount;
            this.purchaseName = tmpSubStrip.serviceNamestr;
            this.purchaseSaparName = tmpSubStrip.saparName.trim();
            this.purchaseNumColor = tmpSubStrip.numColor;
            // if (!this.purchaseAmount && this.purchaseTotal) {
            //     this.purchaseAmount = 1;
            // }
            // if (!this.purchaseDiscountPrice) {
            //     this.purchaseDiscountPrice = this.purchaseTotal;
            // }
            // if (!this.purchaseDiscount) {
            //     if (this.purchaseDiscountPrice > this.purchaseCurrentCost) {
            //         this.purchaseDiscountPercent= 0;
            //     }
            //     else {
            //         this.purchaseDiscountPercent= (1 - this.purchaseCurrentCost / this.purchaseDiscountPrice) * 100;
            //     }
            // }
        }
        else if (menu_id == 5 && order_id == 2) {
            // delete product with confirmation
            let tmpKey: string = this.subStripId.split(" ")[0];

            if (!this.visits.find(x => x.dkey == tmpKey).isHaveComments || this.multi[tmpKey].filter(x => x.isDeleted == false).length != 1) {
                this.isDeletingPurchase = true;
            }
            else {
                this.showMessage("error", "לא ניתן להסיר את המוצר");
            }
        }
    }

    moreStripsButton(): void {
        this.httpServiceCustomer.getVisitByStep(this.customerstepvisitin)
            .subscribe((res: Visit) => {
                const tempComponentHasChanged = this.componentHasChanged;

                this.visit.total.dateEvent = res.total.dateEvent;
                this.visit.total.showMoreButton = res.total.showMoreButton;
                this.customerstepvisitin.dateEvent = res.total.dateEvent;

                let tempVisitsByStep: StripVisitType[] = res.strips.slice().sort((item1, item2) => {
                    return this.commonFunc.stringToDate(item2.dateVisit).getTime() - this.commonFunc.stringToDate(item1.dateVisit).getTime();
                });
                tempVisitsByStep.forEach((item: StripVisitType) => item.isChanged = false);
                this.visits = [...this.visits, ...tempVisitsByStep];

                this.tmpVisits = this.visits;

                if (!tempComponentHasChanged) {
                    setTimeout(() => {
                        this.hostListenerBeforeUnload.resetComponentHasChanged();
                    }, 0);
                }
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }

    // Function of increasing the amount in the input range
    incrementAmount(): void {
        this.purchaseAmount = (+this.purchaseAmount + 1).toString();
        if (+this.purchaseAmount > 99) {
            this.purchaseAmount = "99";
            return;
        }
        this.purchaseTotal = (+this.purchaseTotal + +this.purchaseDiscountPrice).toString();
    }

    // Function of reducing the amount in the input range
    decrementAmount(): void {
        this.purchaseAmount = (+this.purchaseAmount - 1).toString();
        if (+this.purchaseAmount < 1) {
            this.purchaseAmount = "1";
            return;
        }
        this.purchaseTotal = (+this.purchaseTotal - +this.purchaseDiscountPrice).toString();
    }

    // Function that selects text inside the range on focus
    onRangeFocus(target: HTMLInputElement): void {
        target.select();
    }

    // Function that calculates all numeric fields when entering new values in editing modals
    onInputCalculation(modal: string, field: string, eventTarget: HTMLInputElement): void {
        if (field == "discount") {
            if (modal == "purchase") {
                this.purchaseDiscountPercent = this.fixModalInput(this.purchaseDiscountPercent, "0", "100", true);

                eventTarget.value = this.purchaseDiscountPercent;

                this.purchaseDiscountPrice = (+this.purchaseClientPrice * (1 - +this.purchaseDiscountPercent / 100)).toString().split(".")[0];
                this.purchaseTotal = (+this.purchaseDiscountPrice * +this.purchaseAmount).toString();
            }
            else if (modal == "service") {
                this.serviceDiscountPercent = this.fixModalInput(this.serviceDiscountPercent, "0", "100", true);

                eventTarget.value = this.serviceDiscountPercent;

                this.serviceDiscountPrice = (+this.serviceClientPrice * (1 - +this.serviceDiscountPercent / 100)).toString().split(".")[0];
                this.serviceTotal = this.serviceDiscountPrice;
            }
        }
        else if (field == "price") {
            if (modal == "purchase") {
                this.purchaseDiscountPrice = this.fixModalInput(this.purchaseDiscountPrice, "0", "99999", false)

                eventTarget.value = this.purchaseDiscountPrice;

                if (this.purchaseDiscountPrice == "0") {
                    this.purchaseDiscountPercent = "100";
                }
                else if (+this.purchaseDiscountPrice > +this.purchaseClientPrice) {
                    this.purchaseDiscountPercent = "0";
                }
                else {
                    this.purchaseDiscountPercent = ((1 - +this.purchaseDiscountPrice / +this.purchaseClientPrice) * 100).toString();
                    if (this.purchaseDiscountPercent.includes(".") && this.purchaseDiscountPercent.split(".")[1].length > 2) {
                        this.purchaseDiscountPercent = (+this.purchaseDiscountPercent).toFixed(2);
                    }
                }
                this.purchaseTotal = (+this.purchaseDiscountPrice * +this.purchaseAmount).toString();
            }
            else if (modal == "service") {
                this.serviceDiscountPrice = this.fixModalInput(this.serviceDiscountPrice, "0", "99999", false)

                eventTarget.value = this.serviceDiscountPrice;

                if (this.serviceDiscountPrice == "0") {
                    this.serviceDiscountPercent = "100";
                }
                else if (+this.serviceDiscountPrice > +this.serviceClientPrice) {
                    this.serviceDiscountPercent = "0";
                }
                else {
                    this.serviceDiscountPercent = ((1 - +this.serviceDiscountPrice / +this.serviceClientPrice) * 100).toString();
                    if (this.serviceDiscountPercent.includes(".") && this.serviceDiscountPercent.split(".")[1].length > 2) {
                        this.serviceDiscountPercent = (+this.serviceDiscountPercent).toFixed(2);
                    }
                }
                this.serviceTotal = this.serviceDiscountPrice;
            }
        }
        else if (field == "amount") {
            if (modal == "purchase") {
                this.purchaseAmount = this.fixModalInput(this.purchaseAmount, "1", "99", false);

                eventTarget.value = this.purchaseAmount;

                this.purchaseTotal = (+this.purchaseDiscountPrice * +this.purchaseAmount).toString();
            }
        }
    }

    // Function of fixing a certain field in editing modals
    fixModalInput(value: string, min: string, max: string, isPointAvailable: boolean): string {
        if (isPointAvailable) {
            value = value.replace(/[^0-9*.#]/g, "");
            if (value[0] == "0" && value[1] != ".") {
                value = value.replace(/^0+/, '');
            }
            if (value.includes(".")) {
                if (value.match(/\./g).length > 1) {
                    value = value.split(".")[0] + "." + value.split(".")[1];
                }
                if (value.split(".")[1].length > 2) {
                    value = parseFloat(value).toFixed(2);
                }
            }
        }
        else {
            value = value.replace(/[^0-9]/g, "");
            if (value[0] == "0") {
                value = value.replace(/^0+/, "");
            }
        }
        if (!value) {
            value = min;
        }
        else if (parseFloat(value) > parseFloat(max)) {
            value = max;
        }
        return value;
    }

    // Visit filtering function
    filterDataVisit(): void {
        this.tmpVisits = this.visits;

        if (this.classificationOption !== "הכל") {
            const classificationindex = this.customClassificationVisit.indexOf(this.classificationOption);

            if (classificationindex === 2) {
                this.tmpVisits = this.tmpVisits.filter((x) => x.numFilter === 2 || x.numFilter === 4);
            }
            else if (classificationindex === 3) {
                this.tmpVisits = this.tmpVisits.filter((x) => x.numFilter === 3 || x.numFilter === 4);
            }
            if (classificationindex === 1) {
                this.tmpVisits = this.tmpVisits.filter((x) => x.numFilter === 1);
            }
        }

        console.log(this.customClassificationVisit.indexOf(this.classificationOption))
        console.log(this.dateClassificationVisit.indexOf(this.dateclassificationOption))
        console.log(this.visits, this.tmpVisits.filter((x) => x.numColor === this.dateClassificationVisit.indexOf(this.dateclassificationOption)), this.tmpVisits)
        if (this.dateclassificationOption !== "הכל") {
            const dateclassificationindex = this.dateClassificationVisit.indexOf(this.dateclassificationOption);
            this.tmpVisits = this.tmpVisits.filter((x) => x.numColor === dateclassificationindex);
        }

        // Go to the first page and scroll up on filtering
        if (this.maintable) {
            this.maintable.first = 0;
            console.dir(this.maintable.el.nativeElement.parentElement);
            this.maintable.el.nativeElement.parentElement.scrollTo({ top: 0 });
        }

        console.log("Count of visitrs after filtering: " + this.tmpVisits.length);
    }

    // Function of expansion substrips
    onRowExpand(event: any): void {
        console.log("Row expanded:", event);
        let stripin = new StripIn();
        stripin.customerId = event.data.customerId;
        stripin.dateVisit = event.data.dateVisit;
        stripin.numColor = event.data.numColor;

        if (!this.multi[event.data.dkey]) {
            // Get VisitDetails list
            this.httpServiceCustomer.getVisitDetails(stripin)
                .subscribe((res: SubStripVisit[]) => {
                    //this.multi[event.data.dateVisit+'!'+event.data.numColor] = res.slice();//.reverse();
                    this.multi[event.data.dkey] = res.slice();
                }, error => {
                    console.log(error);
                    this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
                });
        }
    }

    // Function that opens comment editing modal
    addOrEditComment(dkey: string): void {
        this.stripId = dkey;
        this.openedComment = this.visits.find((x) => x.dkey == this.stripId).comments;
        this.isEditComment = true;
    }

    // Function of saving visit comment
    saveComment(): void {
        this.visits.find(x => x.dkey == this.stripId).comments = this.openedComment;
        console.log(this.openedComment);
        console.log(this.visits, this.stripId);
        if (this.openedComment) {
            this.visits.find(x => x.dkey == this.stripId).isHaveComments = true;
        }
        else {
            this.visits.find(x => x.dkey == this.stripId).isHaveComments = false;
        }
        this.isEditComment = false;
    }

    // Function of saving purchase changes in the modal
    saveEditedPurchase(): void {
        let tmpSubStrip: SubStripVisit = this.multi[this.subStripId.split(" ")[0]].find((x) => x.id == this.subStripId.split(" ")[1]);
        let tmpStrip: StripVisitType = this.visits.find(x => x.dkey == this.subStripId.split(" ")[0])

        if (this.purchaseNumColor != 1) {
            this.visit.total.total_sum = this.visit.total.total_sum - +tmpSubStrip.pricePerchase + +this.purchaseTotal;
            this.visit.total.purchase_sum = this.visit.total.purchase_sum - +tmpSubStrip.pricePerchase + +this.purchaseTotal;
            this.visit.total.averageVisit = +(this.visit.total.total_sum / this.visit.total.countOfVisits).toFixed(2);
        }

        tmpStrip.total_payed = tmpStrip.total_payed - +tmpSubStrip.pricePerchase + +this.purchaseTotal;
        tmpStrip.isChanged = true;

        tmpSubStrip.pricePerchase = this.purchaseTotal;
        tmpSubStrip.amount = this.purchaseAmount;
        tmpSubStrip.discountPrice = this.purchaseDiscountPrice;
        tmpSubStrip.percentAmount = this.purchaseDiscountPercent;
        tmpSubStrip.saparId = this.workers.find(x => x.saparName.trim() == this.purchaseSaparName.trim()).saparId;
        tmpSubStrip.saparName = this.purchaseSaparName;

        this.showMessage("success", "עודכן בהצלחה");
        this.isEditPurchase = false;
    }

    // Function of saving service changes in the modal
    saveEditedService(): void {
        let tmpSubStrip: SubStripVisit = this.multi[this.subStripId.split(" ")[0]].find((x) => x.id == this.subStripId.split(" ")[1]);
        let tmpStrip: StripVisitType = this.visits.find(x => x.dkey == this.subStripId.split(" ")[0])

        if (this.servicesNumColor != 1) {
            this.visit.total.total_sum = this.visit.total.total_sum - +tmpSubStrip.pricePerchase + +this.serviceTotal;
            this.visit.total.services_sum = this.visit.total.services_sum - +tmpSubStrip.pricePerchase + +this.serviceTotal;
            this.visit.total.averageVisit = +(this.visit.total.total_sum / this.visit.total.countOfVisits).toFixed(2);
        }

        tmpStrip.total_payed = tmpStrip.total_payed - +tmpSubStrip.pricePerchase + +this.serviceTotal;
        tmpStrip.isChanged = true;

        tmpSubStrip.pricePerchase = this.serviceTotal;
        tmpSubStrip.discountPrice = this.serviceDiscountPrice;
        tmpSubStrip.percentAmount = this.serviceDiscountPercent;

        this.showMessage("success", "עודכן בהצלחה");
        this.isEditService = false;
    }

    // Function of deleting purchase
    deletePurchase(): void {
        this.isDeletingPurchase = false;

        this.multi[this.subStripId.split(" ")[0]].find((x) => x.id == this.subStripId.split(" ")[1]).isDeleted = true;

        let tmpStrip: StripVisitType = this.visits.find((x) => x.dkey == this.subStripId.split(" ")[0]);
        let tmpSubStrip: SubStripVisit[] = this.multi[this.subStripId.split(" ")[0]];

        // changing purchase list
        let tmpName = tmpStrip.itemsName.split(tmpSubStrip.find((x) => x.id == +this.subStripId.split(" ")[1]).serviceNamestr + ",");
        if (!tmpName[1]) {
            tmpStrip.itemsName = tmpName[0] + tmpName[1];
        }
        else {
            tmpStrip.itemsName = "לא נמכרו מוצרים";
        }

        tmpStrip.countPurchase--;
        tmpStrip.total_payed -= +tmpSubStrip.find((x) => x.id == +this.subStripId.split(" ")[1]).pricePerchase;

        if (!tmpSubStrip.filter(x => x.isDeleted == false).length) {
            tmpStrip.isDeleted = true;
        }
        else if (!tmpSubStrip.filter(x => x.isService == 2 && x.isDeleted == false).length) {
            tmpSubStrip.find(x => x.id == 0).isDeleted = true;
        }

        this.showMessage("success", "מוצר נמחק בהצלחה");
        console.log(this.tmpVisits)
    }

    // Function of closing all modals
    cancelButton(): void {
        this.isEditComment = false;
        this.isEditPurchase = false;
        this.isEditService = false;
        this.isDeletingPurchase = false;
    }

    // Mobile info panels toggle function
    togglePanelsInfo(): void {
        if (!this.isPanelsInfoOpened) {
            this.isPanelsInfoOpened = true;
        }
        else {
            this.isPanelsInfoOpened = false
        }
    }

    // Strip menu toggle function
    toggleSubMenu(event: PointerEvent, menu: Menu, dkey: string, isMobile: boolean): void {
        this.stripId = dkey;
        if (isMobile) {
            this.isVisitMenuOpened = true;
        }
        else {
            menu.toggle(event);
            if (this.openedMenu && this.openedMenu != menu) {
                this.openedMenu.hide();
            }
            this.openedMenu = menu;
        }
    }

    getTotalSum(): number {
        if (this.visit && this.visit.total) {
            return this.visit.total.total_sum || 0;
        }

        return 0;
    }

    getServicesSum(): number {
        if (this.visit && this.visit.total) {
            return this.visit.total.services_sum || 0;
        }

        return 0;
    }

    getPurchaseSum(): number {
        if (this.visit && this.visit.total) {
            return this.visit.total.purchase_sum || 0;
        }

        return 0;
    }

    getAverageVisit(): number {
        if (this.visit && this.visit.total) {
            return this.visit.total.averageVisit || 0;
        }

        return 0;
    }

    getCountOfVisits(): number {
        if (this.visit && this.visit.total) {
            return this.visit.total.countOfVisits || 0;
        }

        return 0;
    }

    // Subtrip menu toggle function
    toggleSubMenuDetails(event: PointerEvent, menu: Menu, ind: string, id: number, isMobile: boolean, isService: number): void {
        this.subStripId = ind + " " + id;
        if (isMobile) {
            if (isService == 1) {
                this.isServiceMenuOpened = true;
            }
            else if (isService == 2) {
                this.isPurchaseMenuOpened = true;
            }
        }
        else {
            menu.toggle(event);
            if (this.openedMenu && this.openedMenu != menu) {
                this.openedMenu.hide();
            }
            this.openedMenu = menu;
        }
    }

    // Function that displays a pop-up message 
    showMessage(severity: string, summary: string): void {
        clearTimeout(this.messageVisibleTimeout);

        if (document.querySelector(".ui-messages") && this.messageSummary != summary) {
            this.messageService.clear();

            this.messageService.add({ severity, summary });
            this.messageSummary = summary;
            this.messageVisibleTimeout = setTimeout(() => {
                this.messageService.clear();
            }, 3500);
        }
        else {
            if (document.querySelector(".ui-messages")) {
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
            else {
                this.messageService.add({ severity, summary });
                this.messageSummary = summary;
                this.messageVisibleTimeout = setTimeout(() => {
                    this.messageService.clear();
                }, 3500);
            }
        }
    }

    // Check if the control with the given id is disabled for the user by his role
    isDisabled(id: number): boolean {
        if (this.controlsService.custcardviewControlsData) {
            let control = this.controlsService.custcardviewControlsData.find((control) => control.cb_id == id);
            if (!control) {
                return false;
            }
            let enabledRole = control.cb_is_enabled_role;
            let userRole = sessionStorage.getItem("userRole");
            return +userRole < +enabledRole;
        }
    }

    // Function of saving changes
    saveVisits(): void {
        console.log(this.componentHasChanged)
        if (this.componentHasChanged) {
            this.saveData = true;
            this.httpServiceCustomer.setVisits(this.visits)
                .then((res: SetValid) => {
                    this.receivedvalid = res;
                    this.receivedvalid.answer = res.answer;
                    console.log("Visitsstrips data is saved: " + this.receivedvalid.answer);
                }, error => {
                    console.log(error);
                    this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
                });
            this.httpServiceCustomer.setSubStripsVisits(this.multi, this.keylength)
                .then((res: SetValid) => {
                    this.receivedvalid = res;
                    this.receivedvalid.answer = res.answer;
                    console.log("Visitssubstrips data is saved: " + this.receivedvalid.answer);
                }, error => {
                    console.log(error);
                    this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
                });
        }
    }
}
